import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DhlServicePoint } from 'skladon-types';
import { DhlServicePointsStateType } from 'src/types/dhlServicePoints';
import { formatData } from './functions';

const initialState: DhlServicePointsStateType = {
    loading: false,
    data: undefined,
    points: [],
    error: false,
};

const mergePoints = (existing: DhlServicePoint[], incoming: DhlServicePoint[]): DhlServicePoint[] => {
    const byId = new Map<string, DhlServicePoint>();
    existing.forEach((point) => byId.set(point.servicePointId, point));
    incoming.forEach((point) => byId.set(point.servicePointId, point));
    return Array.from(byId.values());
};

export const dhlServicePointsSlice = createSlice({
    name: 'dhlServicePoints',
    initialState,
    reducers: {
        getDhlServicePointsFetch: (state, _action) => {
            state.loading = true;
            state.error = false;
        },
        getDhlServicePointsFetchSuccess: (
            state,
            action: PayloadAction<{ points: DhlServicePoint[]; merge?: boolean }>
        ) => {
            state.points = action.payload.merge
                ? mergePoints(state.points, action.payload.points)
                : action.payload.points;
            state.data = formatData(state.points);
            state.loading = false;
        },
        getDhlServicePointsFetchFailure: (state, action: PayloadAction<{ merge?: boolean } | undefined>) => {
            // Map pan failures must not wipe already loaded points
            if (!action.payload?.merge) {
                state.data = null;
                state.points = [];
            }
            state.loading = false;
            state.error = true;
        },
        getDhlServicePointByIdFetch: (state, _action) => {
            state.loading = true;
            state.error = false;
        },
        getDhlServicePointByIdFetchSuccess: (state, action: PayloadAction<DhlServicePoint>) => {
            const exists = state.points.some((point) => point.servicePointId === action.payload.servicePointId);
            if (!exists) {
                state.points = [action.payload, ...state.points];
                state.data = formatData(state.points);
            }
            state.loading = false;
        },
        getDhlServicePointByIdFetchFailure: (state) => {
            state.loading = false;
            state.error = true;
        },
        clearDhlServicePoints: (state) => {
            state.data = undefined;
            state.points = [];
            state.error = false;
        },
    },
});

export const {
    getDhlServicePointsFetch,
    getDhlServicePointsFetchSuccess,
    getDhlServicePointsFetchFailure,
    getDhlServicePointByIdFetch,
    getDhlServicePointByIdFetchSuccess,
    getDhlServicePointByIdFetchFailure,
    clearDhlServicePoints,
} = dhlServicePointsSlice.actions;

export default dhlServicePointsSlice.reducer;
